import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
  }

  .button-group {
    display: flex;
    flex-wrap: nowrap;
  }

  ::slotted(.he-button-group__button--compound) {
    height: auto;
  }
`;
